module.exports = __webpack_public_path__ + "static/media/embedded.13c3dd45.pdf";